<template>
  <div class="">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="个人资料">
        <section class="user_data">
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">头像 :</p>
              <div>
                <div style="width: 88px; height: 88px; position: relative; border-radius: 50%; overflow: hidden;"
                  @mousemove="(showChangeAvatar = true)" @mouseout="(showChangeAvatar = false)">
                  <a-avatar :class="{ transparent: tempUrl, avatar: editStatus.headImgUrl }" :size="88"
                    :src="(userData.headImgUrl || defaultAvatar)" />
                  <div class="changeAvatarBtn" v-show="showChangeAvatar">更换
                    <!-- :class="{ transparent: !tempUrl }" v-show="showChangeAvatar" -->
                    <upload style="width: 100%; height: 100%;top: 0; opacity: 0" listType="text" :limitNum="1" :width="30"
                      path="img/art/" @uploadChange="uploadChange"></upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">昵称 :</p>
              <p class="font600" v-show="!editStatus.nickName">{{ userData.nickName }}</p>
              <a-input style="background: #F5F7FA; border: none; width: 265px;
border-radius: 4px;" :maxLength="20" v-show="editStatus.nickName" v-model="params.nickName" @blur="nameBlur"></a-input>
            </div>
            <template v-if="editStatus.nickName">
              <div class="edit-btn">
                <p style="margin-right: 10px;" @click="cancleEdit('nickName')">取消</p>
                |
                <p style="margin-left: 10px;" @click="eidtIsSave('nickName')">完成</p>
              </div>
            </template>
            <template v-else>
              <div class="edit-btn" @click="showEdit('nickName')">
                修改
              </div>
            </template>
          </div>
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">手机号 :</p>
              <p class="font600" v-show="!editStatus.phoneNumber">{{ userData.phoneNumber || '未绑定' }}</p>
            </div>
            <div class="edit-btn" @click="showEdit('phoneNumber')">
              修改
            </div>
          </div>
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">微信号 :</p>
              <p class="font600">{{ userData.wxBindFlag ? userData.wxName : '未绑定' }}</p>
            </div>
            <div class="edit-btn" @click="bindWechatBtn">
              {{ userData.wxBindFlag ? '换绑微信' : '绑定' }}
            </div>
          </div>
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">你的性别 :</p>
              <p class="font600" v-show="!editStatus.sex">{{ userData.sex == '0' ? '女' : '男' }}</p>
              <a-radio-group v-show="editStatus.sex" v-model="params.sex">
                <a-radio value="1">
                  男
                </a-radio>
                <a-radio value="0">
                  女
                </a-radio>
              </a-radio-group>
            </div>
            <template v-if="editStatus.sex">
              <div class="edit-btn">
                <p style="margin-right: 10px;" @click="cancleEdit('sex')">取消</p>
                |
                <p style="margin-left: 10px;" @click="eidtIsSave('sex')">完成</p>
              </div>
            </template>
            <template v-else>
              <div class="edit-btn" @click="showEdit('sex')">
                修改
              </div>
            </template>
          </div>
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">生日 :</p>
              <p class="font600" v-show="!editStatus.birthday">{{ userData.birthday || '未知' }}</p>
              <a-date-picker style="background: #F5F7FA; border: none; width: 265px;
border-radius: 4px;" :disabled-date="disabledDate" :allowClear="false" :value="params.birthday"
                :default-value="moment(userData.birthday || Date.now())" v-show="editStatus.birthday"
                @change="dateChange" />
            </div>
            <template v-if="editStatus.birthday">
              <div class="edit-btn">
                <p style="margin-right: 10px;" @click="cancleEdit('birthday')">取消</p>
                |
                <p style="margin-left: 10px;" @click="eidtIsSave('birthday')">完成</p>
              </div>
            </template>
            <template v-else>
              <div class="edit-btn" @click="showEdit('birthday')">
                修改
              </div>
            </template>
          </div>
          <div class="data_item">
            <div class="flexAlcenter">
              <p class="item_title">所在城市 :</p>
              <p class="font600" v-show="!editStatus.address">{{ address ? (`${userData.provinceName || ''}
                              ${userData.cityName ||
                ''} ${userData.countyName || ''}` || '未知') : '未知'
              }}</p>
              <a-cascader style="background: #F5F7FA; border: none; width: 265px;
border-radius: 4px; border: none;" v-show="editStatus.address" :allowClear="false"
                :field-names="{ label: 'name', value: 'code', children: 'children' }" :options="options"
                placeholder="选择城市" change-on-select @change="cascaderChange" />
            </div>
            <template v-if="editStatus.address">
              <div class="edit-btn">
                <p style="margin-right: 10px;" @click="cancleEdit('address')">取消</p>
                |
                <p style="margin-left: 10px;" @click="eidtIsSave('address')">完成</p>
              </div>
            </template>
            <template v-else>
              <div class="edit-btn" @click="showEdit('address')">
                修改
              </div>
            </template>
          </div>
          <div class="data_item" v-if="userData.college">
            <div class="flexAlcenter">
              <p class="item_title">报考院校 :</p>
              <p class="font600">{{ userData.college ? userData.college : '' }}</p>
            </div>
          </div>
          <div class="data_item" v-if="userData.major">
            <div class="flexAlcenter">
              <p class="item_title">报考专业 :</p>
              <p class="font600">{{ userData.major ? userData.major : '' }}</p>
            </div>
          </div>
          <!-- <a-button :loading="loading" type="primary" @click="eidtIsSave">{{ isEdit ? '保存' : '修改' }}</a-button> -->
        </section>
      </a-tab-pane>
      <a-tab-pane key="2" tab="修改密码">
        <edit-pass ref="editPass"></edit-pass>
        <!-- <a-form-model :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
          <a-form-model-item label="旧密码">
            <a-input placeholder="请输入旧密码"></a-input>
          </a-form-model-item>
          <a-form-model-item label="新密码">
            <a-input placeholder="请输入新密码"></a-input>
          </a-form-model-item>
          <a-form-model-item label="确认新密码">
            <a-input placeholder="请再次输入新密码"></a-input>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ offset: 3 }">
            <a-button type="primary" @click="onSubmit">
              保存
            </a-button>
          </a-form-model-item>
        </a-form-model> -->
      </a-tab-pane>
    </a-tabs>
    <scanWechatPopVue :show.sync="editStatus.wxBindFlag" />
    <ModifyPhone :show.sync="editStatus.phoneNumber" :phone="userData.phoneNumber" @success="modifyPhone" />
  </div>
</template>
<script>
import moment from 'moment'
import Upload from '@/components/Upload/Upload.vue'
import ModifyPhone from './components/modifyPhone.vue'
import editPass from './components/EditPass'
import scanWechatPopVue from './components/scanWechatPop.vue'
import { getMapJSON } from '@/api/system'
import { updateUserInfo, bindWechat, changebindWechat, getStuInfo } from '@/api/user'
import { transformUrl } from '@/utils/util'
import { nameReg } from '@/utils/regs'
import { mapState } from 'vuex'
import axios from 'axios'
const defaultAvatar = require('@/assets/defaultAvatar.png')

export default {
  name: '',
  data() {
    return {
      showChangeAvatar: false,
      defaultAvatar,
      nameReg,
      tempUrl: '',
      isEdit: false,
      value: 0,
      options: [],
      params: {},

      editStatus: {},
      rules: {
        nickName: [
          { required: true, message: '昵称不能为空', trigger: 'none' },
          { pattern: nameReg, message: '昵称只能是汉字、大小写字母、数字和标点符号', trigger: 'none' }
        ]
      },
      loading: false,
      temAddress: ''
    }
  },

  computed: {
    userData() {
      const data = this.$store.getters.getUserData([
        'id',
        'nickName',
        'headImgUrl',
        'phoneNumber',
        'cityName',
        'countyName',
        'provinceName',
        'sex',
        'wxBindFlag',
        'birthday',
        'college',
        'major',
        'wxName'
      ])
      return data
    },
    address() {
      const { cityName, countyName, provinceName } = this.userData
      const arr = [provinceName, cityName, countyName]
      arr.map((item, index) => {
        if (!item) {
          arr.splice(index, 1)
        }
      })
      return arr.join('') || this.temAddress
    },
    birthdayDefault() {
      const { birthday } = this.userData
      return birthday ? moment(birthday) : birthday
    },
    ...mapState({
      info: state => state.system.orgInfo
    })
  },
  watch: {
    userData: {
      handler(val) {
        for (const key in val) {
          if (Object.hasOwnProperty.call(val, key)) {
            this.$set(this.editStatus, key, false)
          }
        }
        this.$set(this.editStatus, 'address', false)
      },
      deep: true,
      immediate: true
    },
    async $route() {
      const authCode = this.getWechatAuthCode()
      console.log('authCode', authCode)
      if (authCode) {
        try {
          let res
          if (this.wxBindFlag) {
            res = await changebindWechat({ code: authCode, ocode: this.info.ocode })
          } else {
            res = await bindWechat({ code: authCode, ocode: this.info.ocode })
          }
          res && this.$message.success('绑定成功')
          const resInfo = await getStuInfo()
          delete res.token
          this.$store.commit('UPDATA_USER_INFO', resInfo)
          this.$router.push({ path: '/study/account', replace: true, query: { ocode: Vue.ls.get('code') } })
          this.editStatus.wxBindFlag = false
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  components: {
    Upload,
    editPass,
    ModifyPhone,
    scanWechatPopVue
  },
  async created() {
    // this.featchAreaDataAsync()
    console.log('wwwww')
    const res = await getMapJSON()
    if (!res) return
    const areaJSON = await axios({
      url: res
    })
    this.options = areaJSON.data
  },
  methods: {
    moment,
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    bindWechatBtn() {
      this.editStatus.wxBindFlag = true
    },
    // 获取回调code
    getWechatAuthCode() {
      let code = ''
      if (!location.hash && !location.search) return code
      const paramsPart = location.hash
        ? `?${location.hash.split('?')[1] || ''}`
        : location.search

      const searchPms = new URLSearchParams(paramsPart)
      code = searchPms.get('code') || ''
      return code
    },
    modifyPhone(phoneNumber) {
      this.params.phoneNumber = phoneNumber
      // this.eidtIsSave('phoneNumber')
    },
    showEdit(editType) {
      console.log(this.userData[editType])
      this.$set(this.params, editType, this.userData[editType])
      this.editStatus[editType] = true
    },
    cancleEdit(editType) {
      if (editType === 'birthday' && !this.userData[editType]) {
        this.$set(this.params, 'birthday', moment(Date.now()))
        this.editStatus[editType] = false
      } else {
        this.$set(this.params, editType, this.userData[editType])
        this.editStatus[editType] = false
      }
    },
    callback() {
      this.isEdit = false
      this.$refs.editPass && this.$refs.editPass.resetForm()
    },
    updataInfo(data) {
      console.log(data)
      if (data.headImgUrl) {
        data.headImgUrl = transformUrl(data.headImgUrl)
        this.tempUrl = ''
      }
      this.$message.success('修改成功')
    },
    async updateUserInfoAsync(params) {
      try {
        this.loading = true
        const res = await updateUserInfo(params)
        delete res.token
        this.$store.commit('UPDATA_USER_INFO', res)
        res && this.updataInfo(params)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        // this.isEdit = !this.isEdit
      }
    },
    nameBlur() {
      const { nickName } = this.params
      // const is = nameReg.test(nickName.trim())
      // const reg = /^[\u4e00-\u9fa5a-zA-Z0-9,.! ?=+-]+$/gi
      // console.log('test', ('asdasdasdasdasdasd'.match(reg)))
      // console.log('nickName', nickName)
      // console.log('nameReg', nameReg)
      if (!nickName.trim()) {
        this.$message.error('昵称不能为空')
        return
      }
      // console.log(!(reg.test('asdasdasdasdasdasd')))
      // console.log('test', !(reg.test('asdasdasdasdasdasd')))
      if (!nameReg.test(nickName.trim())) {
        this.$message.error('昵称只能是汉字、大小写字母、数字和标点符号')
        return
      }
      nameReg.lastIndex = 0
    },
    eidtIsSave(editType) {
      if (editType === 'address') {
        const {
          cityName, countyName, provinceName
        } = this.params
        if (!cityName && !countyName && !provinceName) {
          this.$message.error('请选择所在城市')
          return
        }
        this.updateUserInfoAsync({
          cityName,
          countyName,
          provinceName,
          id: this.userData.id
        })
      } else if (editType === 'birthday') {
        if (!this.params.birthday) {
          this.$set(this.params, 'birthday', moment(Date.now()).format('YYYY-MM-DD'))
        }
        this.updateUserInfoAsync({
          [editType]: this.params[editType],
          id: this.userData.id
        })
      } else if (editType === 'nickName') {
        const { nickName } = this.params
        if (!nickName.trim()) {
          this.$message.error('昵称不能为空')
          return
        }
        if (!nameReg.test(nickName.trim())) {
          this.$message.error('昵称只能是汉字、大小写字母、数字和标点符号')
          return
        }
        this.updateUserInfoAsync({
          [editType]: this.params[editType],
          id: this.userData.id
        })
      } else {
        this.updateUserInfoAsync({
          [editType]: this.params[editType],
          id: this.userData.id
        })
      }
      this.editStatus[editType] = false
      // } else {
      //   this.params.sex = String(this.userData.sex)
      //   this.params.nickName = this.userData.nickName
      //   !this.options.length && this.featchAreaDataAsync()
      // }
      // this.isEdit = !this.isEdit
    },
    onSubmit() { },
    // 时间回调
    dateChange(date, dateString) {
      this.params.birthday = dateString
    },
    // 省市区选中回调
    cascaderChange(value, value2) {
      console.log(value, value2)
      if (!value2) return
      const address = value2.map(item => item.name)
      this.temAddress = address.join('')
      this.$set(this.params, 'provinceName', value2[0] && value2[0].name || '')
      this.$set(this.params, 'cityName', value2[1] && value2[1].name || '')
      this.$set(this.params, 'countyName', value2[2] && value2[2].name || '')
    },
    // 头像选中回调
    uploadChange(ev) {
      this.tempUrl = ev[0]
      if (ev[0]) {
        this.params.headImgUrl = ev[0]
        this.eidtIsSave('headImgUrl')
      }
      if (!ev[0] && this.params.headImgUrl) {
        Reflect.deleteProperty(this.params, 'headImgUrl')
      }
    },
    // 获取地区数据
    // async featchAreaDataAsync (id) {
    //   try {
    //     const res = await featchAreaData(id)
    //     res.forEach(item => {
    //       if (item.areaLevel !== 3) {
    //         Reflect.deleteProperty(item, 'children')
    //         item.isLeaf = false
    //       }
    //     })
    //     if (!id) {
    //       this.options = res
    //     }
    //     return res
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    // 地区控件异步获取数据
    // async loadData (ev) {
    //   const targetOption = ev[ev.length - 1]
    //   targetOption.loading = true
    //   try {
    //     const res = await this.featchAreaDataAsync(targetOption.id)
    //     targetOption.loading = false
    //     targetOption.children = res
    //     this.options = [...this.options]
    //     console.log(this.options, 'optionsoptions')
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
  }
}
</script>
<style lang="less" scoped>
.font600 {
  font-weight: 600;
}

.changeAvatarBtn {
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
  text-align: center;
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.user_data {
  box-sizing: border-box;
  padding-left: 30px;
  padding-right: 52px;
  color: #303133;

  .data_item {
    display: flex;
    min-height: 32px;
    align-items: center;
    margin-bottom: 15px;
    justify-content: space-between;

    p {
      margin-bottom: 0;
    }

    input {
      box-sizing: border-box;
      // width: 370px;
      background: #f5f8fa;
      border-radius: 6px;
      padding-right: 30px;
      font-size: 14px;
    }

    /deep/ .ant-cascader-input {
      border: none;
    }

    .ant-calendar-picker {
      /deep/ .ant-calendar-picker-input {
        background: #F5F7FA;
        border: none;
      }
    }

    .edit-btn {
      font-size: 14px;
      font-weight: 400;
      color: #4b7dfd;
      cursor: pointer;
      display: flex;
      width: 120px;
      justify-content: flex-end;

      p {
        margin-bottom: 0;
      }
    }

    .item_title {
      width: 75px;
      margin-right: 30px;
      text-align: left;
    }

    .ant-input,
    .ant-calendar-picker,
    .ant-cascader-picker {
      width: 310px;
    }

    .ant-radio-wrapper {
      color: #181d21;
    }
  }

  .avatar {
    position: relative;

    &::after {
      content: '更换头像';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      font-size: 14px;
      background-color: rgba(0, 0, 0, 0.7);
    }
  }

  .clearfix {
    position: absolute;
    top: 85px;

    /deep/.ant-upload {
      font-size: 14px;
      font-weight: 400;
      color: rgb(255, 255, 255);
      text-align: center;
      display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
    }
  }

  .ant-btn {
    margin-left: 105px;
    background-color: #1564ff;
  }

  .transparent {
    opacity: 0;
  }
}

/deep/.ant-tabs-nav {
  padding-left: 16px;
}

/deep/.ant-tabs-bar {
  margin: 0 0 40px !important;
}

/deep/.ant-tabs-tab {
  padding: 4px 0px 19px;
  font-size: 18px !important;
  font-family: PingFangSC-Medium, PingFang SC;
}

/deep/.ant-tabs-tab-active .ant-tabs-ink-bar {
  color: #1564ff;
  font-weight: bold;
}

.flexAlcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modify-phone {
  .title {
    text-align: center;
    font-weight: 600;
  }
}</style>
